/* eslint-disable react/jsx-handler-names */
import cx from "classnames";
import { find, get } from "lodash";
import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBContainer,
  MDBRow
} from "mdbreact";
import React from "react";
import { connect } from "react-redux";
import PKHBtn from "~/components/common/atoms/Button";
import Select from "~/components/common/atoms/Select";
import TagName from "~/components/common/atoms/TagName";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { getNextStep } from "~/store/filter/actions";
import styles from "./style.module.scss";

import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

class InstructionIncorrectBHYT extends React.Component {
  constructor(props) {
    super(props);
    this.listInCorrectBHYT = [
      { id: "TAI_KHAM", name: `Tái khám theo lịch hẹn` },
      {
        id: "CHUYEN_TUYEN",
        name: `Chuyển tuyến`
      }
    ];
    const idParams = get(this.props, "match.params.id", 0);
    this.state = {
      id: idParams,
      insuranceChoice: "TAI_KHAM"
    };
  }

  handleContinueAction = () => {
    const { getNextStep } = this.props;
    const { id, insuranceChoice } = this.state;

    const objNext = {
      id,
      plattform: "app",
      insurance: insuranceChoice
    };

    getNextStep(objNext);
  };

  onChangeType = id => {
    this.setState({
      insuranceChoice: id
    });
  };

  render() {
    return (
      <div style={{ marginTop: "calc(-7vh)" }}>
        <MDBContainer>
          <MDBRow className="row_mobile">
            <MDBCol md="12" lg="9">
              <MDBCard className={cx(styles.panels, styles.panel_mobile)}>
                <MDBCardHeader className={styles.panels_header}>
                  <TagName
                    element="h2"
                    className={[
                      "title_component",
                      "title_choose_date",
                      "space_between",
                      "title_header_mobile"
                    ]}
                  >
                    <span>
                      Quy định dành cho bệnh nhân khám Bảo hiểm (Chuyển Tuyến)
                    </span>
                  </TagName>
                </MDBCardHeader>
                <MDBCardBody className={styles.card_body}>
                  <div className={styles.list_type}>
                    <span>Vui lòng chọn hình thức bảo hiểm</span>
                    <Select
                      data={this.listInCorrectBHYT}
                      onChange={this.onChangeType}
                    />
                  </div>
                  <div className={styles.list_type}>
                    <span>
                      Vui lòng xác nhận có các loại giấy tờ sau khi đến khám
                      bệnh:
                    </span>
                    {this.state.insuranceChoice === "TAI_KHAM" ? (
                      <div className={styles.instruction}>
                        - Thẻ Bảo hiểm Y tế còn hạn.
                        <br />- Giấy hẹn tái khám.
                      </div>
                    ) : (
                      <div className={styles.instruction}>
                        - Thẻ Bảo hiểm Y tế còn hạn.
                        <br />- Giấy chuyển tuyến hợp lệ
                      </div>
                    )}
                  </div>
                </MDBCardBody>
                <div className={styles.next_prev}>
                  <PKHBtn
                    onClick={this.handleContinueAction}
                    buttonArrow="buttonArrow"
                    nextStep
                    create="create"
                  >
                    Tiếp tục
                  </PKHBtn>
                </div>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

const InstructionIncorrectBHYTHelmet = withTitle({
  component: InstructionIncorrectBHYT,
  title: `${hospitalName.value} | Hướng dẫn BHYT`
});

export default connect(null, { getNextStep })(InstructionIncorrectBHYTHelmet);
